/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createForEach } from '../../factoriesAny.js';
export var forEachDependencies = {
  typedDependencies,
  createForEach
};